import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Modal from '../../../components/Modal';
import '../../../components/styles/simpleTable.css';

const styles = {};

class UserTableModal extends Component {
  constructor(props) {
    super(props);
  }

  openModal = () => {
    this.setState({ isModalOpen: true });
  };

  closeModal = () => {
    this.setState({ isModalOpen: false });
  };

  render() {
    const getActiveSubscription = item =>
      item.subscriptions.find(
        sub =>
          new Date(sub.start_at).getTime() <= new Date().getTime() &&
          new Date().getTime() < new Date(sub.end_at).getTime(),
      );

    return (
      <React.Fragment>
        <Modal
          title={this.props.title}
          subtitle={this.props.subtitle}
          show={this.props.isModalOpen}
          onClose={this.props.closeModal}
        >
          <table id="simple-table">
            <tbody style={{ height: '45vh' }}>
              <tr>
                <th style={{ width: '25%' }}>Id</th>
                <th style={{ width: '50%' }}>Telefono</th>
                <th style={{ width: '50%' }}>Email</th>
                <th style={{ width: '50%' }}>Piano</th>
              </tr>
              {this.props.users &&
                this.props.users.map((user, index) => (
                  <tr key={index}>
                    <td style={{ width: '25%' }}>{user.id}</td>
                    <td style={{ width: '50%' }}>{user.phone_number || ''}</td>
                    <td style={{ width: '50%' }}>{user.email}</td>
                    <td style={{ width: '50%' }}>
                      {getActiveSubscription(user)
                        ? getActiveSubscription(user).plan.name
                        : 'Nessun piano attivo / Ereditato'}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </Modal>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(UserTableModal);



// WEBPACK FOOTER //
// ./src/resources/dashboard/modals/UserTableModal.jsx